import axios from "axios";
import {
  requestHandler,
  successHandler,
  errorHandler,
  requestSuperAdminHandler
} from "../interceptor";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});
export const axiosSuperAdminInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});
// Handle request process
axiosInstance.interceptors.request.use((request) =>
  requestHandler(request)
);
// Handle response process
axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

axiosSuperAdminInstance.interceptors.request.use((request) =>
  requestSuperAdminHandler(request)
);
